import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../component/layout';

import ExpenseCategoryTab from './expense_tabs/expense_category';
import ExpenseTab from './expense_tabs/expense';
import ExpenseCalendarTab from './expense_tabs/expense_calendar';

function ExpenseManagement() {
    const [activeTab, setActiveTab] = useState('category');
    
    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={"/facility/"}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"/facility/expense_management"}>
                                        Expense Management
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-body py-0">
                                                    <ul className="nav nav-tabs profile-tabs">
                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link ${activeTab === 'category' ? 'active' : ''}`}
                                                                onClick={() => setActiveTab('category')}
                                                                type="button"
                                                            >
                                                                <i className="ti ti-plus me-2"></i>Expense Category
                                                            </button>
                                                        </li>
                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link ${activeTab === 'expenses' ? 'active' : ''}`}
                                                                onClick={() => setActiveTab('expenses')}
                                                                type="button"
                                                            >
                                                                <i className="ti ti-list me-2"></i>Expenses
                                                            </button>
                                                        </li>
                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link ${activeTab === 'calendar' ? 'active' : ''}`}
                                                                onClick={() => setActiveTab('calendar')}
                                                                type="button"
                                                            >
                                                                <i className="ti ti-calendar me-2"></i>Calendar
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div className="tab-content" style={{ paddingTop: '1rem' }}>
                                                {activeTab === 'category' && (
                                                    <ExpenseCategoryTab />
                                                )}
                                                {activeTab === 'expenses' && (
                                                    <ExpenseTab />
                                                )}
                                                {activeTab === 'calendar' && (
                                                    <ExpenseCalendarTab />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default ExpenseManagement;